<template>
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="" aria-hidden="true" ref="modalEle">
    <div class="modal-dialog modal-dialog-centered" @click="handleOutsideClick">
      <div class="modal-content">
        <div class="modal-header border-0 py-0">
          <h5 class="modal-title" id="exampleModalLabel" v-if="!modalBodyVideo">{{ title }}</h5>
          <button type="button" class="btn-close-new" data-bs-dismiss="modal"><i class="fa-solid fa-xmark"></i></button>
        </div>
        <div class="modal-body">
          <!-- <video ref="myVideo" style="width: 100%" controls v-if="modalBodyVideo">
             <source :src="`${getVideo}`" type="video/mp4">
            --<source :src="heroVideo" type="video/mp4">
            Your browser does not support the video tag.
            </video> -->
          <iframe v-if="modalBodyVideo" :src="getVideo" style="width: 100%; height: 500px;" frameborder="0"
            allowfullscreen></iframe>
          <div v-else>
            <slot name="body"></slot>
          </div>
        </div>
        <div class="modal-footer" v-if="modalBodyVideo === false">
          <slot name="footer"></slot>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="stopVideo">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue';
import { Modal } from 'bootstrap';
import { computed } from 'vue';
import { useStore } from 'vuex';
const props = defineProps({
  title: {
    type: String,
    default: '<<Title goes here>>',
  },
  modalBodyVideo: {
    type: Boolean,
    default: false,
  },
});
const modalEle = ref(null);
const myVideo = ref(null);
let modalInstance = null;
let modalHiddenHandler = null;
const store = useStore();
const getVideo = computed(() => { return store.getters.getVideo })
onMounted(() => {
  if (modalEle.value) {
    modalInstance = new Modal(modalEle.value);
    modalHiddenHandler = () => {
      if (myVideo.value) {
        myVideo.value.pause();
      }
    };
    modalEle.value.addEventListener('hidden.bs.modal', modalHiddenHandler);
  }
});
onBeforeUnmount(() => {
  if (modalInstance) {
    modalInstance.dispose();
  }
  if (modalEle.value && modalHiddenHandler) {
    modalEle.value.removeEventListener('hidden.bs.modal', modalHiddenHandler);
  }
});
function _show() {
  if (modalInstance) {
    modalInstance.show();
  }
}
defineExpose({ show: _show });
</script>
<style scoped>
.modal-body {
  padding-bottom: 15px !important;
  padding-top: 8px;
  background: transparent;
}

.modal-dialog {
  width: 100%;
}

.modal-dialog {
  max-width: 60%;
}

.modal-content {
  background: #fff;
  border: 0;
}

.btn-close-new {
  font-size: 1.5625rem;
  padding: 0 10px;
  margin: 0;
  border: 0;
  background: transparent;
  color: #00d9ff;
}

@media screen and (max-width: 576px) {
  .modal-dialog {
    max-width: 98%;
  }
}

@media (min-width: 576px) and (max-width: 768px) {
  .modal-dialog {
    max-width: 95%;
  }
}
</style>